/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type PaymentOptionEnum = 's' | 'w' | 'u' | '11184809';

export const PaymentOptionEnum = {
  S: 's' as PaymentOptionEnum,
  W: 'w' as PaymentOptionEnum,
  U: 'u' as PaymentOptionEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as PaymentOptionEnum
};
